import React from 'react';
import TablaEntes from '../components/entes/tablaEntes';

function Entes() {
    return (
        <div className='col-sm-12 d-flex justify-content-center m-0'>
            <TablaEntes />
        </div>
    );
}

export default Entes;




// WEBPACK FOOTER //
// ./src/pages/entes.js